import { useSignatureImageUrl } from './useSignatureImageUrl';

/**
 * Image dessinée d'une signature (détail d'une feuille), rien sans image ; label : le signataire (Employé…).
 * Sur papier blanc en mode nuit : l'encre bleu nuit serait illisible sur fond sombre
 */
export function SignatureImage({ signatureUrn, label }: { signatureUrn: string; label: string }) {
  const { url } = useSignatureImageUrl(signatureUrn);

  if (!url) return null;

  return (
    <img
      src={url}
      alt={`Signature ${label}`}
      className="mt-2 h-14 max-w-full object-contain object-left dark:bg-white dark:rounded dark:p-1"
    />
  );
}
